// src/config/wsServerInfoConfig.js (NEW FILE)

/**
 * Defines message types and STOMP topics for general server info retrieval,
 * typically used for the initial connection before module-specific actions.
 */
export const WS_SERVER_INFO_TYPES = {
    // --- Client -> Server ---
    CONNECT_SERVER: 'SERVER_CONNECT',       // Client requests connection and info for an IP
    DISCONNECT_SERVER: 'SERVER_DISCONNECT', // Optional: Client explicitly requests disconnect (often handled by WS closure)
    GET_SERVER_STATE: 'SERVER_GET_STATE', // Optional: Client requests current connection state if reconnecting

    // --- Server -> Client (User Queue) ---
    SERVER_INFO_UPDATE: 'SERVER_INFO_UPDATE', // Server sends back the fetched server status info (or confirms connection)
    SERVER_INFO_ERROR: 'SERVER_INFO_ERROR',   // Server sends an error related to connection or info fetching
    // CURRENT_SERVER_STATE: 'SERVER_CURRENT_STATE' // Optional: Response to GET_SERVER_STATE
};

export const WS_SERVER_INFO_TOPICS = {
    // --- Destinations for Client Commands ---
    APP_ENDPOINT_BASE: '/server', // Base path for server-related commands
    APP_CONNECT: '/connect',          // Endpoint for sending CONNECT_SERVER message
    APP_DISCONNECT: '/disconnect',    // Optional: Endpoint for sending DISCONNECT_SERVER
    APP_GET_STATE: '/get-state',      // Optional: Endpoint for GET_SERVER_STATE

    // --- User-Specific Subscription Topics ---
    // Base path for messages directed to a specific user related to server info
    USER_QUEUE_BASE: '/user/queue/server',
    // Sub-topic where the server sends successful info updates
    USER_INFO: '/info',
    // Sub-topic where the server sends errors related to this specific process
    USER_ERROR: '/error', // Changed from '/errors' in HomePage to be module-specific
    // USER_STATE: '/state' // Optional: Sub-topic for CURRENT_SERVER_STATE

    // --- Public Broadcast Topics (If any needed for general server info) ---
    // Example: Might not be needed for user-specific info requests
    // PUBLIC_TOPIC_BASE: '/topic/server',
    // PUBLIC_INFO: '/info',
};

// --- Helper Functions ---

/**
 * Builds the full application endpoint path for server info actions.
 * @param {string} action - The relative action path (e.g., WS_SERVER_INFO_TOPICS.APP_CONNECT).
 * @returns {string} The full STOMP destination path (e.g., '/app/server/connect').
 */
export const getServerInfoAppEndpoint = (action) => {
    return `${WS_SERVER_INFO_TOPICS.APP_ENDPOINT_BASE}${action}`;
};

/**
 * Builds the full user-specific queue topic path for server info subscriptions.
 * @param {string} subTopic - The relative sub-topic path (e.g., WS_SERVER_INFO_TOPICS.USER_INFO).
 * @returns {string} The full user-specific STOMP topic path (e.g., '/user/queue/server/info').
 */
export const getServerInfoUserQueueTopic = (subTopic) => {
    return `${WS_SERVER_INFO_TOPICS.USER_QUEUE_BASE}${subTopic}`;
};

// Example Usage:
// sendMessage(getServerInfoAppEndpoint(WS_SERVER_INFO_TOPICS.APP_CONNECT), { ip: '...' });
// subscribe(getServerInfoUserQueueTopic(WS_SERVER_INFO_TOPICS.USER_INFO), handleInfoUpdate);
// subscribe(getServerInfoUserQueueTopic(WS_SERVER_INFO_TOPICS.USER_ERROR), handleErrorUpdate);